import React from 'react';

// The three steps to get notifications on an iPhone or iPad: add the app to
// the Home Screen first, then turn them on from there.
// browser is 'safari' or 'chrome'; anything else gets the Safari wording.
export default function IosSteps({ browser = 'safari' }) {
  const first = browser === 'chrome'
    ? 'Tap Share in the address bar'
    : 'Tap the three dots in the address bar, then Share';
  return (
    <ol className="notif-steps">
      <li>{first}</li>
      <li>Tap View More, then Add to Home Screen</li>
      <li>Open the app from your Home Screen and tap Turn on notifications</li>
    </ol>
  );
}
